<template>
    <div class="modal">
        <div class="modal__container">
            <div class="modal__inner">
                <a href="#" class="modal__close" @click="close">
                    <i class="fas fa-times"></i>
                </a>

                <div class="wrapper">
                    <h2 style="margin-top: 10px;">{{ __("Enquire Now") }}</h2>

                    <form action="" v-on:submit.prevent="submitForm" method="post" class="form">
                        <div class="form__field">
                            <input
                                type="text"
                                id="enquiryName"
                                v-model="enquiry.name"
                                class="form__input form__input--secondary"
                                :placeholder="__('Name')"
                                required
                            />
                        </div>
                        <div class="form__field">
                            <input
                                type="email"
                                id="enquiryEmail"
                                v-model="enquiry.email"
                                class="form__input form__input--secondary"
                                :placeholder="__('Email Address')"
                                required
                            />
                        </div>
                        <div class="form__field">
                            <input
                                type="text"
                                id="enquiryPhone"
                                v-model="enquiry.phone"
                                class="form__input form__input--secondary"
                                :placeholder="__('Phone Number')"
                                required
                            />
                        </div>
                        <div class="form__field">
                            <textarea
                                id="enquiryMessage"
                                v-model="enquiry.message"
                                class="form__input form__input--secondary"
                                rows="5"
                                maxlength="1000"
                                :placeholder="__('Enquiry')"
                                required
                            />
                        </div>
                        <div
                            class="alert alert--sml alert--error alert--left"
                            v-if="errors && errors.length > 0"
                            role="alert"
                        >
                            <span v-for="(error, index) in errors" v-html="__(error)" :key="index"></span>
                        </div>

                        <div class="auth__btn">
                            <button class="auth__btn__item btn btn--quaternary" type="submit">
                                {{ __("Submit") }}
                            </button>
                        </div>
                    </form>

                    <div class="loading loading--primary" v-if="loading">
                        <div class="loading__inner">
                            <div class="loading__spinner"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ticket-enquiry-modal",
    props: {
        eventScheduleId: {
            type: String,
            required: false
        },
        ticketType: {
            type: String,
            required: false
        }
    },
    data: function() {
        return {
            errors: [],
            loading: false,
            enquiry: {
                name: "",
                email: "",
                phone: "",
                message: "",
                eventScheduleId: this.eventScheduleId,
                ticketType: this.ticketType
            }
        };
    },
    methods: {
        submitForm() {
            axios
                .post("/events/enquire", this.enquiry)
                .then(response => {
                    this.errors = [];
                    if (response.data.success) {
                        this.$toasted.show("Thank you, your enquiry has been submitted", {
                            theme: "bubble",
                            type: "success",
                            position: "top-center",
                            duration: 3000
                        });
                        this.$emit("close", true);
                    } else {
                        this.errors.push(this.__("There was an error submitting the form"));
                        this.loading = false;
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.errors = [];
                    if (typeof error.response.data.errors != "undefined") {
                        for (let key in error.response.data.errors) {
                            let err = error.response.data.errors[key];
                            if (typeof err == "string") {
                                this.errors.push(err);
                            } else {
                                for (let nKey in err) {
                                    this.errors.push(err[nKey]);
                                }
                            }
                        }
                    } else {
                        this.errors.push("There was an error submitting the form");
                    }
                    this.loading = false;
                });
        },
        close() {
            this.$emit("close", true);
        }
    }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// resources/js/components/ticket-enquiry-modal.vue